export class HideAndShowHelper {
  static isScrollable(el: Element, index: number | null = null): boolean {
    const hideAndShowWrapper = ".hideAndShowWrapper";
    let hideAndShow: HTMLDivElement | null = null;

    if (index === null) {
      hideAndShow = el.querySelector(hideAndShowWrapper) as HTMLDivElement;
    } else {
      const hideAndShows = el.querySelectorAll(hideAndShowWrapper);
      if (index < hideAndShows.length) {
        hideAndShow = hideAndShows[index] as HTMLDivElement;
      }
    }

    return hideAndShow !== null && hideAndShow.scrollWidth > hideAndShow.clientWidth;
  }
}
